import { render, staticRenderFns } from "./WurldSelect.vue?vue&type=template&id=4415131e&"
import script from "./WurldSelect.vue?vue&type=script&lang=js&"
export * from "./WurldSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WurldSelect.vue"
export default component.exports